module.exports = __webpack_public_path__ + "5c10ccb437398d365dca28dddd558923.svg";